"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _StyleConfig = require("../utils/StyleConfig");
var _ListGroup = _interopRequireDefault(require("./_ListGroup"));
var _ListItem = _interopRequireDefault(require("./_ListItem"));
var _ListContext = _interopRequireDefault(require("./_ListContext"));
var _ListConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-concur_android.css") : void 0);
var _ListConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-concur_default.css") : void 0);
var _ListConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-concur_gateway.css") : void 0);
var _ListConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-concur_ios.css") : void 0);
var _ListSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-sap_fiori_3_dark.css") : void 0);
var _ListSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-sap_fiori_3_hcb.css") : void 0);
var _ListSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-sap_fiori_3_hcw.css") : void 0);
var _ListSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-sap_fiori_3.css") : void 0);
var _ListSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-sap_horizon_dark.css") : void 0);
var _ListSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-sap_horizon_hcb.css") : void 0);
var _ListSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-sap_horizon_hcw.css") : void 0);
var _ListSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List-sap_horizon.css") : void 0);
var _excluded = ["bordered", "children", "className", "classNameMap", "size", "type"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _ListConcur_android.default,
  concur_default: _ListConcur_default.default,
  concur_gateway: _ListConcur_gateway.default,
  concur_ios: _ListConcur_ios.default,
  sap_fiori_3_dark: _ListSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _ListSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _ListSap_fiori_3_hcw.default,
  sap_fiori_3: _ListSap_fiori_.default,
  sap_horizon_dark: _ListSap_horizon_dark.default,
  sap_horizon_hcb: _ListSap_horizon_hcb.default,
  sap_horizon_hcw: _ListSap_horizon_hcw.default,
  sap_horizon: _ListSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-list';

/**
 * The **List** component can be used to display a homogeneous set of basic data
 * with a single-level hierarchy.
 */

var List = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var bordered = props.bordered,
    children = props.children,
    className = props.className,
    classNameMap = props.classNameMap,
    size = props.size,
    type = props.type,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(classNameMap);
  var isUsingGroups = _react.default.Children.toArray(children).some(function (child) {
    var _child$type;
    return (child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'List.Group';
  });
  var listContextValue = {
    bordered: bordered,
    isUsingGroups: isUsingGroups,
    size: size,
    type: type
  };
  var classes = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--").concat(size), !!size));
  return /*#__PURE__*/_react.default.createElement(_ListContext.default.Provider, {
    value: listContextValue
  }, /*#__PURE__*/_react.default.createElement(_ListGroup.default, (0, _extends2.default)({}, otherProps, {
    className: classes,
    isRoot: true,
    ref: ref
  }), children));
});
List.displayName = 'List';
List.propTypes = _objectSpread(_objectSpread({}, _ListGroup.default.propTypes), {}, {
  /** Set to `true` to add bottom borders to list items. */
  bordered: _propTypes.default.bool,
  /** Size of the element. Options are `'lg'`, `'md'`. */
  size: _propTypes.default.oneOf(_StyleConfig.CONTROL_SIZES),
  /** Type of list to render. Options are `'ordered'`, `'unordered'`. */
  type: _propTypes.default.oneOf(_StyleConfig.LIST_TYPES)
});
List.defaultProps = {
  size: 'lg',
  type: 'unordered'
};
List.Group = _ListGroup.default;
List.Item = _ListItem.default;
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(List);
exports.default = _default;